<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container contents">
        <!-- Page Features -->
        <div class="pt-0 pt-md-3">
          <div id="cart-page">
            <!-- End Transparent Message -->
            <div class="row ">
              <div class="col-lg-8">
                <section class="checkout-header p-3">
                  <h1 class="align-self-center" id="numberofproduct">
                    শপিং কার্ট ({{ cart.length }} Item)
                  </h1>
                  <h1
                    id="payabletotaltext"
                    class="text-right">
                    মোট: Tk. <em class="total-amount">{{ amount }}</em>
                  </h1>
                </section>

                <section id="cart-content">
                  <div v-for="(item, k) in cart" :key="k" class="cart-item">
                    <div class="row no-gutters">
                      <!-- Book Cover Section -->
                      <div class="col-lg-2 col-2">
                        <div class="pl-2">
                          <a :href="`/book/${item.product_id}`">
                            <img
                              class="img-fluid cart-image"
                              :src="`${IMAGEURL}${item.image}`"
                              alt=""
                            />
                          </a>
                        </div>
                      </div>

                      <div class="col-lg-3 col-10 px-2">
                        <a :href="`/book/${item.product_id}`">
                          {{ item.name }}
                        </a>
                      </div>
                      <!-- Book Info Section -->
                      <div class="col-lg-7 col-12 p-sm-2 p-md-0">
                        <div class="book-info">
                          <div class="book-info__content">
                            <div class="book-info__content--book-action">
                              <a
                                @click="removeFromCart(item)"
                                href="javascript:;"
                                class="js-remove-product ml-2"
                              >
                                <i class="fa fa-trash-o text-danger"></i>
                              </a>
                            </div>
                          </div>
                          <div class="book-info__content">
                            <div class="book-info__content--book-action">
                              <p
                                class="js--prc text-right"
                              >
                                Tk. <span>{{item.price}}</span>
                              </p>
                            </div>
                          </div>
                          <div class="book-info__content--quantity">
                            <button
                              class="btn js-minus-btn"
                              id="btn-minus"
                              @click="decQty(item)"
                            >
                              <i class="fa fa-minus"></i>
                            </button>
                            <input
                              type="text"
                              class="form-control js-quantity-input product-qty bg-white"
                              :id="`qty-${item.product_id}`"
                              :value="`${item.quantity}`"
                              disabled
                            />
                            <button
                              class="btn js-plus-btn"
                              id="btn-plus"
                              @click="incQty(item)"
                            >
                              <i class="fa fa-plus"></i>
                            </button>
                          </div>
                          <div class="book-info__content--price">
                            <div
                              class="price-info d-flex justify-content-between"
                            >
                              <p
                                class="js--prc text-right"
                                data-baseprice="230.0"
                              >
                                Tk.
                                <span :id="`price-${item.product_id}`">{{
                                  (item.quantity * item.price).toFixed(2)
                                }}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Cart Item -->
                </section>
              </div>
              
              <div class="col-lg-4">
                <section class="shipping-address mb-4 p-3">
                  <div class="checkout-sidebar__header border-heading">
                      <h1>শপিং ঠিকানা</h1>
                    </div>
                  <form>
                    <div class="form-group">
                      <label for="mobile">মোবাইল নাম্বার<span class="text-danger">*</span></label>
                      <input 
                        type="text" 
                        class="form-control" 
                        id="mobile"
                        v-model="customerInfo.mobile"
                        :class="{'is-invalid': mobileError, 'is-valid': isValidMobile}"
                        placeholder=" আপনার মোবাইল নাম্বার এখানে লিখুন"
                        @input="validateMobile"
                      >
                      <div class="invalid-feedback" v-if="mobileError">
                        সঠিক মোবাইল নাম্বার দিন (১১ ডিজিট)
                      </div>
                      <small class="form-text text-success" v-if="isValidMobile">
                        <i class="fa fa-check-circle"></i>
                      </small>
                    </div>

                    <div class="form-group">
                      <label for="name">নাম<span class="text-danger">*</span></label>
                      <input 
                        type="text" 
                        class="form-control" 
                        id="name"
                        v-model="customerInfo.name"
                        placeholder=" আপনার নাম লিখুন"
                      >
                      <small class="form-text text-success" v-if="customerInfo.name">
                        <i class="fa fa-check-circle"></i>
                      </small>
                    </div>

                    <div class="form-group">
                      <label for="address">ঠিকানা<span class="text-danger">*</span></label>
                      <input 
                        type="text" 
                        class="form-control" 
                        id="address"
                        v-model="customerInfo.address"
                        placeholder="আপনার ঠিকানা লিখুন"
                      >
                      <small class="form-text text-success" v-if="customerInfo.address">
                        <i class="fa fa-check-circle"></i>
                      </small>
                    </div>
                  </form>
                </section>

                <div class="fixed-checkout">
                  <section id="checkout-sidebar" class="check-sidebar p-3">
                    <div class="checkout-sidebar__header">
                      <h1>চেকআউট সামারি</h1>
                    </div>

                    <div class="d-flex justify-content-between summary-row">
                      <div>সাব টোটাল</div>
                      <div>Tk. {{ amount }}</div>
                    </div>


                    <div class="d-flex justify-content-between summary-row">
                      <div>ডিসকাউন্ট</div>
                      <div>Tk. {{ discount }}</div>
                    </div>

                    <!-- <div class="d-flex justify-content-between summary-row">
                      <div>টোটাল</div>
                      <div>Tk. {{ amount }}</div>
                    </div> -->

                    <div
                      class="d-flex justify-content-between summary-row border-bottom-0 mb-4"
                    >
                      <div>গ্রান্ড টোটাল</div>
                      <div>Tk. {{ grandTotal }}</div>
                    </div>

                    <div class="checkout-sidebar__content">
                      <div class="payment-breakdown">
                        <div class="payment-breakdown__content"></div>
                      </div>
                      <div class="gift-wrap">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="js-gift-checkbox"
                            @click="giftToggle"
                          />
                          <label
                            class="custom-control-label"
                            for="js-gift-checkbox"
                          >
                            Gift Wrap for Tk. 20
                          </label>
                        </div>
                      </div>
                    </div>
                    <!--End checkout-sidebar__content -->
                  </section>
                  <div class="coupon-section">
                    <div class="card">
                      <div class="js--coupon-header">
                        <!-- Accordion -->
                        <div id="accordionExample" class="accordion shadow">
                          <!-- Accordion item 1 -->
                          <div class="card">
                            <div
                              id="headingOne"
                              class="card-header bg-white shadow-sm border-0"
                            >
                              <h2 class="mb-0">
                                <button
                                  type="button"
                                  data-toggle="collapse"
                                  data-target="#collapseOne"
                                  aria-expanded="false"
                                  aria-controls="collapseOne"
                                  class="btn btn-link text-dark font-weight-bold text-uppercase collapsible-link"
                                >
                                  Add Promo code or Gift voucher
                                </button>
                              </h2>
                            </div>
                            <div
                              id="collapseOne"
                              aria-labelledby="headingOne"
                              data-parent="#accordionExample"
                              class="collapse"
                            >
                              <div class="card-body p-3">
                                <div class="input-group">
                                  <input
                                    v-model="promoCode"
                                    type="text"
                                    class="form-control"
                                    :disabled="couponDisabled == 1"
                                    :placeholder="`${placeHolder}`"
                                    aria-label="Recipient's username"
                                    aria-describedby="basic-addon2"
                                  />
                                  <div class="input-group-append">
                                    <button
                                      @click="validatePromo"
                                      class="btn btn-outline-secondary"
                                      type="button"
                                      :disabled="couponDisabled == 1"
                                    >
                                      Apply
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- End -->
                        </div>
                        <!-- End -->
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="checkout-footer" id="js-shipping"></div> -->
                <div class="mt-3 mb-1 d-flex">
                  <a
                    href="/"
                    class="btn btn-info flex-grow-1 flex-fill mr-2"
                    id="js-continue-to-shipping"
                    ><i class="fa fa-chevron-circle-left"></i> আরও বই দেখুন
                  </a>
                  <button
                    :disabled="!isValidForCheckout"
                    @click="goToCheckout"
                    href="javascript:;"
                    class="btn btn-primary flex-grow-1 flex-fill"
                    id="js-continue-to-gift-shipping"
                    >অর্ডার সম্পন্ন করুন <i class="fa fa-chevron-circle-right"></i>
                  </button>
                </div>

                <div v-if="deliveryContents" class="bg-light p-2 font-14 mt-3">
                  <div class="d-flex" v-if="deliveryContents.title">
                    <div class="p-1">
                      <i class="fa fa-cash-register"></i>
                    </div>
                    <div class="p-1">
                      {{ deliveryContents.title }}
                    </div>
                  </div>
                  <div class="d-flex" v-if="deliveryContents.short_description">
                    <div class="p-1">
                      <i class="fa fa-undo-alt"></i>
                    </div>
                    <div class="p-1">
                      {{ deliveryContents.short_description }}
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="p-1">
                      <i class="fa fa-truck"></i>
                    </div>
                    <div class="p-1">
                      {{ deliveryContents.custom_field }}
                      <div>
                        {{ deliveryContents.custom_field2 }}
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="p-1">
                      <i class="fa fa-trophy"></i>
                    </div>
                    <div class="p-1">
                      {{ deliveryContents.custom_field3 }}
                      <div>
                        {{ deliveryContents.custom_field4 }}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  name: `Cart`,
  components: {
    Layout
  },
  computed: {
    isValidCustomerInfo() {
      return this.isValidMobile &&
             this.customerInfo.name.trim() !== '' &&
             (this.customerInfo.address || '').trim() !== '';
    },
    isValidForCheckout() {
      return this.isValidCustomerInfo && this.cart.length > 0;
    }
  },
  data() {
    return {
      errors: [],
      cart: [],
      formData: {
        email: null,
        password: null
      },
      amount: 0,
      grandTotal: 0.0,
      discount: 0.0,
      deliveryCharge: 0.0,
      gift: false,
      giftPrice: 0,
      promoAmount: 0,
      couponDisabled: 0,
      promoCode: "",
      promo: null,
      placeHolder: "Enter your promo code",
      deliveryContents: {},
      customerInfo: {
        mobile: '',
        name: '',
        address: ''
      },
      mobileError: false,
      isValidMobile: false
    };
  },
  mounted() {
    /* 1 Initialize gift */
    this.giftPrice = 0;

    /* 2 Load cart from API */
    this.loadCart();

    /* 3 Reset promo state */
    this.promo = null;
    this.promoCode = "";
    this.discount = 0;

    /* 4 Load delivery content */
    this.getDeliveryContents();

    if (localStorage.getItem("token")) {
      this.couponDisabled = 0;
      this.placeHolder = "Enter your coupon";

      // Set default values from localStorage
      this.customerInfo.name = localStorage.getItem("name") || '';
      this.customerInfo.mobile = localStorage.getItem("mobile") || '';

      // Validate mobile number if it exists
      if(this.customerInfo.mobile) {
        this.validateMobile();
      }
    }
  },
  methods: {
    loadCart() {
      const sessionId = localStorage.getItem("session_id");
      this.$http.get("cart/" + sessionId).then(response => {
        if (response.data.status) {
          this.cart = response.data.cart;
          this.amount = response.data.total;
          localStorage.setItem("cartCount", response.data.count);
          $(".cart-count").text(response.data.count);
          this.recalculateDiscount();
          this.calculateGrandTotal();
        }
      });
    },
    goToCheckout() {
      if(this.cart.length < 1){
        this.flashMessage.error({
          message: "আপনার শপিং কার্ট খালি!!!",
          time: 3000,
          blockClass: 'error-message'
        });
        return false;
      }

      // Store customer info in localStorage
      localStorage.setItem("customerInfo", JSON.stringify(this.customerInfo));

      // Check if all required customer info is filled
      if (!this.customerInfo.mobile || !this.customerInfo.name) {
        this.flashMessage.error({
          message: "দয়া করে আপনার নাম এবং ফোন নম্বর দিন",
          time: 3000,
          blockClass: 'error-message'
        });
        return false;
      }

      if (!this.customerInfo.address || this.customerInfo.address.trim() === '') {
        this.flashMessage.error({
          message: "দয়া করে আপনার ঠিকানা দিন",
          time: 3000,
          blockClass: 'error-message'
        });
        return false;
      }

      if (window.fbq) {
        fbq('track', 'InitiateCheckout', {
          value: this.grandTotal,
          currency: 'BDT',
          num_items: this.cart.length
        });
      }

      // Assign cart to customer by mobile
      this.$http.post("cart/assign", {
        session_id: localStorage.getItem("session_id"),
        customer_mobile: this.customerInfo.mobile,
        customer_name: this.customerInfo.name
      }).then(() => {
        location.href = "checkout";
      }).catch(() => {
        location.href = "checkout";
      });
    },
    clearPromo() {
      this.promo = null;
      this.promoCode = "";
      this.discount = 0;
    },
    recalculateDiscount() {
      const amount = Number(this.amount);

      if (!this.promo) {
        this.discount = 0;
        return;
      }

      // optional minimum cart check
      if (this.promo.min_order_amount && amount < this.promo.min_order_amount) {
        this.discount = 0;
        this.flashMessage.error({
          message: "এই প্রোমো কোডটি ব্যবহার করতে সর্বনিম্ন ৳" + this.promo.min_order_amount + " অর্ডার করতে হবে।"
        });
        return;
      }

      if (this.promo.amount_type === "fixed") {
        this.discount = this.promo.amount;
      } else {
        this.discount = Math.floor((amount * this.promo.amount) / 100);
      }

      localStorage.setItem("discount", this.discount);
    },
    validatePromo() {
      this.$http
        .get("promo/" + this.promoCode)
        .then(response => {
          if (response.data.status) {
            this.promo = response.data.promo;
            localStorage.setItem("promoCode", this.promoCode);
            this.recalculateDiscount();
          } else {
            this.clearPromo();
            localStorage.removeItem("promoCode");
            this.flashMessage.error({
              message: "আপনি ভুল কুপন কোড প্রবেশ করেছেন"
            });
          }

          this.calculateGrandTotal();
        })
    },
    checkForm: function(e) {
      e.preventDefault();

      if (!this.formData.email) {
        this.flashMessage.error({
          message: "আপনার মোবাইল নাম্বার/ইমেইল লিখুন"
        });
        return false;
      }

      if (!this.formData.password) {
        this.flashMessage.error({ message: "আপনার পাসওয়ার্ড লিখুন" });
        return false;
      }

      //console.log(this.formData);
    },
    removeFromCart(item) {
      if (confirm("Are you sure you want to delete?")) {
        this.$http.post("cart/remove", {
          cart_id: item.cart_id,
          session_id: localStorage.getItem("session_id")
        }).then(response => {
          if (response.data.status) {
            $(".cart-count").text(response.data.cart_count);
            localStorage.setItem("cartCount", response.data.cart_count);
            this.loadCart();
          }
        });
      }
    },
    decQty(item) {
      var currentQty = Number(item.quantity) - 1;
      if (currentQty < 1) {
        return false;
      }
      this.$http.post("cart/update-qty", {
        cart_id: item.cart_id,
        quantity: currentQty
      }).then(response => {
        if (response.data.status) {
          this.loadCart();
        }
      });
    },
    incQty(item) {
      var currentQty = Number(item.quantity) + 1;
      if (item.stock && currentQty > Number(item.stock)) {
        this.flashMessage.error({ message: "স্টকে পর্যাপ্ত পরিমাণ নেই" });
        return false;
      }
      this.$http.post("cart/update-qty", {
        cart_id: item.cart_id,
        quantity: currentQty
      }).then(response => {
        if (response.data.status) {
          this.loadCart();
        }
      });
    },
    giftToggle() {
      if (this.gift) this.gift = false;
      else this.gift = true;
      if (this.gift) this.giftPrice = 20;
      else this.giftPrice = 0;

      localStorage.setItem("giftPrice", this.giftPrice);
      localStorage.setItem("gift", true);
      //console.log(localStorage.getItem("gift"));

      this.recalculateDiscount();
      this.calculateGrandTotal();
    },
    calculateGrandTotal() {
      this.grandTotal = (Number(this.amount) + Number(this.deliveryCharge) + Number(this.giftPrice)) - Number(this.discount || 0);
      this.grandTotal = Math.ceil(this.grandTotal).toFixed(2);
    },
    getDeliveryContents() {
      fetch(this.APIURL + "cms-resources/Delivery-Contents")
        .then((response) => response.json())
        .then((json) => {
          this.deliveryContents = json.data[0];
          //console.log('json.data', json.data[0]);
        });
    },
    validateMobile() {
      // Remove any spaces and non-digit characters
      const mobileNumber = this.customerInfo.mobile.replace(/\D/g, '');
      
      // Check if it's a valid Bangladeshi number (11 digits starting with 01)
      const isValid = /^01\d{9}$/.test(mobileNumber);
      
      this.mobileError = mobileNumber.length > 0 && !isValid;
      this.isValidMobile = isValid;
      
      // Update the mobile number to show only digits
      this.customerInfo.mobile = mobileNumber;
    },
  },
  watch: {
    $route(to, from) {
      alert("called it");
    }
  }
};
</script>

<style scoped>
.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 10px;
  border-radius: 4px;
  margin: 10px 0;
  border: 1px solid #f5c6cb;
}
</style>

